const toBoolean = (val: string): Nullable<boolean> =>
  val === 'true' ? true : val === 'false' ? false : null;

export const parseQs = (url: string) => {
  const parsedParams: Record<string, number | boolean | string> = {};

  const qs = url.split('?')[1];
  new URLSearchParams(qs).forEach((val, key) => {
    parsedParams[key] = !isNaN(parseInt(val))
      ? parseInt(val)
      : (toBoolean(val) ?? val);
  });

  return parsedParams;
};
